import AccessSetup from './access-setup';

export default AccessSetup;